<template>
  <div class="finance-box">
    <keep-alive v-if="reload">
        <component :is="curComp" :params.sync="curParams" @changeComp="changeComp" @goBack="goBack"></component>
    </keep-alive> 
  </div>
</template>

<script>
import goldFinancingMain from "@/pages/circulation/gold-financing/gold-financing-main"
import financingGoldDetailModel from "@/pages/circulation/gold-financing/financing-gold-detail-model"
import financingGoldDetailComp from "@/pages/circulation/gold-financing/financing-gold-detail-comp"
import goldFinancingAgreement from "@/pages/circulation/gold-financing/goldFinancingAgreement"
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
    components: {goldFinancingMain,financingGoldDetailModel,goldFinancingAgreement,financingGoldDetailComp},
    data() {
        return {
            curComp:"goldFinancingMain",
            reload:true,
            curParams:null
        };
    },
    computed:{
        ...mapGetters({
            getGoldDetailPrarms:"app/getGoldDetailPrarms"
        })
    },
    methods: {
        ...mapMutations({
            setGoldDetailPrarms:"app/setGoldDetailPrarms",
        }),
        changeComp(params = {}){
            if(params.data){ //把祺信信息存在store中，方便祺信详情组件获取数据
                this.setGoldDetailPrarms(params.data);
                this.curParams = params.data;
            }
            
            this.curComp = params.comp;
            if(params.refresh){
                this.reloadComp();
            }
        },
        reloadComp(){
            this.reload = false;
            this.$nextTick(()=>{
                this.reload = true;
            })
        },
        goBack(refresh){
            this.curComp = "goldFinancingMain";
            if(refresh){
                this.reloadComp();
            }
        }
    },
    created() {
        
    },
    mounted() {},
    activated() {},
    destroyed(){
        this.setGoldDetailPrarms(null);
    }
};
</script>
<style scoped>
.finance-box{
  padding:8px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing.vue